let pendingRestore: Promise<void> | null = null

export const setSessionRestore = (restore: Promise<void> | null) => {
    pendingRestore = restore
}

export const waitForSessionRestore = async (): Promise<void> => {
    await pendingRestore
}
